import { UserPermission } from "helpers/constants/common";

export interface ILinkRequestDto {
  id: string;
  requestorName?: string;
  requestorId?: string;
  requestedId?: string;
  requestedName?: string;
  status: number;
  submittedOn: string;
  submittedBy: string;
  updatedDate?: string;
  updatedBy?: string;
  assignCurrentUser?: boolean;
  notes?: string;
  requestorSites?: string;
  requestedSites?: string;
  requestorDisplayName?: string;
  requestedDisplayName?: string;
  pendingApprovers?: string;
  requestedActualTradingName?: string;
}

export interface ILinkRequestForReview {
  id: string;
  requestor: string;
  requestedId: string;
  requestedTradingName: string;
  requestedActualTradingName: string;
  status: LinkRequestStatusType;
  notes?: string;
}

export interface IGetLinkRequestsRequest {
  pageIndex: number;
  pageSize: number;
  requestorSearchInput?: string;
  requestorSiteSearchList?: string;
  requestedSearchInput?: string;
  requestedSiteSearchList?: string;
  submittedBySearchInput?: string;
  updatedBySearchInput?: string;
  statusSearchList?: string;
  searchCmsUser?: boolean;
}

export interface IGetLinkRequestsResponse {
  getLinkRequestsCms: {
    requests: ILinkRequestDto[];
    responseCode: number;
    errorCode?: string;
    errorMessage?: string;
    totalCount: number;
  };
}

export interface IGetLinkRequestByIdRequest {
  requestId: string;
}

export interface IGetLinkRequestByIdResponse {
  getLinkRequestById: {
    request: ILinkRequestDto;
    responseCode: number;
    errorCode?: string;
    errorMessage?: string;
  };
}

export interface ILinkRequestStatusLabel {
  labelForOthers: string;
  colorForOthers: string;
  labelForMyself?: string;
  colorForMyself?: string;
  labelForFilter?: string;
}

export enum LinkRequestStatusType {
  AwaitingApproval1 = 0,
  AwaitingConfirmation = 1,
  AwaitingApproval2 = 2,
  Approved = 3,
  Rejected = 4,
  Withdrawn = 5,
  Unlinked = 6,
}

export const AllLinkRequestStatusTypes = Object.values(LinkRequestStatusType).filter(
  (v): v is LinkRequestStatusType => typeof v === "number",
);

export const LinkRequestStatusPermissions: Map<number, UserPermission[]> = new Map([
  [LinkRequestStatusType.AwaitingApproval1, [UserPermission.ReviewRequest1st]],
  [LinkRequestStatusType.AwaitingApproval2, [UserPermission.ReviewRequestFinal]],
]);

export const LinkRequestStatusLabelTypes: Map<number, ILinkRequestStatusLabel> = new Map([
  [
    LinkRequestStatusType.AwaitingApproval1,
    {
      labelForOthers: "Awaiting Approval",
      labelForMyself: "Awaiting My Approval",
      labelForFilter: "Awaiting First Approval",
      colorForOthers: "orange",
    },
  ],
  [
    LinkRequestStatusType.AwaitingApproval2,
    {
      labelForOthers: "Awaiting Approval",
      labelForMyself: "Awaiting My Approval",
      labelForFilter: "Awaiting Final Approval",
      colorForOthers: "orange",
    },
  ],
  [
    LinkRequestStatusType.AwaitingConfirmation,
    {
      labelForOthers: "Awaiting Confirmation",
      colorForOthers: "yellow",
      labelForMyself: "Awaiting My Confirmation",
      labelForFilter: "Awaiting Confirmation",
    },
  ],
  [
    LinkRequestStatusType.Approved,
    {
      labelForOthers: "Approved",
      colorForOthers: "green",
      labelForFilter: "Approved",
    },
  ],
  [
    LinkRequestStatusType.Rejected,
    {
      labelForOthers: "Rejected",
      colorForOthers: "grey",
      labelForFilter: "Rejected",
    },
  ],
  [
    LinkRequestStatusType.Withdrawn,
    {
      labelForOthers: "Withdrawn",
      colorForOthers: "grey",
      labelForFilter: "Withdrawn",
    },
  ],
  [
    LinkRequestStatusType.Unlinked,
    {
      labelForOthers: "Unlinked",
      colorForOthers: "grey",
      labelForFilter: "Unlinked",
    },
  ],
]);

export interface ISubmitAccountLinkRequestRequest {
  requestedProducerId: string;
  requestedTradingName: string;
  notes?: string;
}

export interface ISubmitAccountLinkRequestResponse {
  submitAccountLinkRequest: {
    responseCode: number;
    errorCode?: string;
    errorMessage?: string;
  };
}

export interface IGraphQLCmsError {
  errorCode: string;
  errorMessage: string;
  field: string;
}
export interface ISubmitAccountLinkCmsRequestResponse {
  submitAccountLinkCmsRequest: {
    responseCode: number;
    errors?: IGraphQLCmsError[];
  };
}

export enum LinkRequestAction {
  Withdrawn = 0,
  Approve = 1,
  Reject = 2,
}

export interface IEditAccountLinkResponse {
  editAccountLinkRequest: {
    responseCode: number;
    errorCode?: string;
    errorMessage?: string;
  };
}

export interface IUpdateLinkRequestStatusRequest {
  requestId: string;
  toStatus: LinkRequestStatusType;
  requestedTradingName?: string;
}

export interface IUpdateLinkRequestStatusResponse {
  updateLinkRequestStatus: {
    responseCode: number;
    errorCode?: string;
    errorMessage?: string;
  };
}

export const AccountLinkErrorCode = {
  InValid : "VAL_ERR_016",
  AlreadyLinked: "VAL_ERR_023",
  LinkToSelf: "VAL_ERR_024",
  SiteAccessDenied: "VAL_ERR_025",
};
